import React from 'react';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { MoreVertical, Eye, UserCheck, Send, CheckCircle, FolderOpen, Trash2 } from 'lucide-react';

/**
 * Reusable action menu for proposal rows/cards.
 * Receives a proposal object and handler callbacks.
 */
export const ProposalActionsMenu = ({ proposal, onView, onStatusChange, onConvert, onDelete, testIdPrefix = 'actions' }) => {
  const status = proposal.status;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" data-testid={`${testIdPrefix}-${proposal.proposal_id}`}>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onView(proposal)}>
          <Eye className="mr-2 h-4 w-4" />
          View Details
        </DropdownMenuItem>

        {status === 'draft' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onStatusChange(proposal.proposal_id, 'for_review')}>
              <UserCheck className="mr-2 h-4 w-4" />
              Send for Review
            </DropdownMenuItem>
          </>
        )}

        {status === 'for_review' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onStatusChange(proposal.proposal_id, 'sent_to_client')}>
              <Send className="mr-2 h-4 w-4" />
              Mark as Sent to Client
            </DropdownMenuItem>
          </>
        )}

        {status === 'sent_to_client' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onStatusChange(proposal.proposal_id, 'signed')}>
              <CheckCircle className="mr-2 h-4 w-4" />
              Mark as Signed
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onStatusChange(proposal.proposal_id, 'rejected')}>
              <Trash2 className="mr-2 h-4 w-4" />
              Mark as Rejected
            </DropdownMenuItem>
          </>
        )}

        {['signed', 'sent_to_client'].includes(status) && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onConvert(proposal.proposal_id)}>
              <FolderOpen className="mr-2 h-4 w-4" />
              Convert to Project
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => onDelete(proposal.proposal_id)} className="text-destructive">
          <Trash2 className="mr-2 h-4 w-4" />
          Delete Proposal
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
